import PropTypes from 'prop-types';
import React from 'react';

const CustomLabel = (props) => {
  if (props.labelComponent) {
    const CustomLabel = props.labelComponent;

    // strip the label component from the custom component props
    // (prevents infinite loop rendering if someone reuses this component as a custom label component)
    const { labelComponent, ...labelComponentProps } = props;

    return <CustomLabel {...labelComponentProps} />;
  }

  const { field, isValid, children } = props;

  let className = 'form-group__label';

  // if (!isValid) {
  //   className += ' invalid';
  // }

  return (
    <label htmlFor={field.valueField.id} className={className}>
      {children}
      {field.model.title}
    </label>
  );
};

CustomLabel.propTypes = {
  labelComponent: PropTypes.any,
  field: PropTypes.any,
  isValid: PropTypes.any,
  children: PropTypes.any
};

export default CustomLabel;
